import React from 'react'
import PlayButton from './playbutton'
import {Link} from 'react-router-dom';

const Games = () => {
    return (
       <div id="games-available">
           <span className="primary"><i className="fas fa-dice-d6"></i>&nbsp;&nbsp;Available Games :</span>
           <div className="games my-1">
                <div id="game-1" className="game">
                    <img src="https://preview.free3d.com/img/2014/01/2269196347779319477/rx00lcyw-900.jpg" alt="Jump-rider"></img>
                    <div className="game-desc">
                        <h1 className="secondary">Jump Rider</h1>
                        <Link to='/jumprider'><PlayButton/></Link>
                    </div>
                </div>
           </div>
       </div>
    )
}

export default Games
